export const columns = function () {
  // 内保单号，机构名称，车牌号，内保起期，内保止期，参保人，被内保人，车损(内保额度），车损标准内保费，三者(内保额度），三者标准内保费，司机(内保额度），司机标准内保费，乘客(内保额度），乘客标准内保费，应交合计（元），净费合计（元）
  return [
	  {
	    prop: "insBillId",
	    label: "流水号",
	    minWidth: 200,
	  },
    {
      prop: "bh",
      label: "内保单号",
      minWidth: 200,
    },
    {
      prop: "orgName",
      label: "机构名称",
      minWidth: 200,
    },
    {
      prop: "carNo",
      label: "车牌号",
      minWidth: 100,
    },
    {
      prop: "beginTime",
      label: "内保起期",
      minWidth: 200,
    },
    {
      prop: "endTime",
      label: "内保止期",
      minWidth: 200,
    },
    {
      prop: "cperson",
      label: "参保人",
      minWidth: 100,
    },
    {
      prop: "bperson",
      label: "被内保人",
      minWidth: 100,
    },
	{
	  prop: "payTime",
	  label: "交费时间",
	  minWidth: 100,
	},
    {
      prop: "car_tcfee",
      label: "车损(内保额度）",
      minWidth: 100,
    },
    {
      prop: "car_bztcfee",
      label: "车损标准内保费",
      minWidth: 100,
    },
    {
      prop: "three_tcfee",
      label: "三者(内保额度）",
      minWidth: 100,
    },
    {
      prop: "three_bztcfee",
      label: "三者标准内保费",
      minWidth: 100,
    },
    {
      prop: "driver_tcfee",
      label: "司机(内保额度）",
      minWidth: 100,
    },
    {
      prop: "driver_bztcfee",
      label: "司机标准内保费",
      minWidth: 100,
    },
    {
      prop: "passenger_tcfee",
      label: "乘客(内保额度）",
      minWidth: 100,
    },
    {
      prop: "passenger_bztcfee",
      label: "乘客标准内保费",
      minWidth: 100,
    },
	{
	  prop: "medical_tcfee",
	  label: "医保外用药(内保额度）",
	  minWidth: 100,
	},
	{
	  prop: "medical_bztcfee",
	  label: "医保外用药标准内保费",
	  minWidth: 100,
	},
    {
      prop: "yjtcfee",
      label: "应交合计（元）",
      minWidth: 100,
    },
    {
      prop: "netFee",
      label: "净费合计（元）",
      minWidth: 100,
    },
  ];
};

export default {};
